import React, { Fragment, useContext } from "react";
import { AppContext } from "../../../components/AppProvider";
import { IntroContainer } from "../../Layout";

export default (props) => {
    const { userinfo, cfg } = useContext(AppContext);

    const iFrameStyle = {
        borderRadius:"8px",
        width: "100%"
    };
    return(
        <Fragment>
            <div className='contents main' style={{paddingTop:"0px"}}>
                <IntroContainer
                    color="green"
                    returnUrl="/sm/bp/input"
                    url="/sm/bp/input"
                    btnText="내 혈압 측정하기"
                    ppmHeight="auto"
                    ppmMargin="75px"
                >

                    <div
                        style={{
                            padding:"40px 52px"
                        }}
                    >
                        <p style={{
                            fontSize:"22px"
                            , textAlign:"left"
                            , color:"#fff"
                            , fontWeight:"600"
                        }}>
                            {userinfo.userName}님
                            <br />
                            혈압측정 어떻게 하고 계시나요?
                        </p>
                    </div>

                    <div style={{padding:"0px 28px"}}>
                        {
                            props.match.params.auto === "A" && <a style={{fontSize:"14px", float:"right", color:"#fff"}}>다시보지 않기</a>
                        }
                    </div>
                    
                    <div style={{padding:"0px 12vw"}}>
                        <div style={{ paddingTop:"100px", fontSize:"14px", textAlign:"left", fontWeight:"800"}}>
                            "집에서 혈압 측정하면서
                            <br />
                            <font color="#7fd2c2" style={{fontSize:"18px"}}>헷갈리지</font> 않으시나요?"
                        </div>

                        <div style={{paddingTop:"50px", fontSize:"14px", textAlign:"center", fontWeight:"800"}}>
                            <font color="#7fd2c2" style={{fontSize:"18px"}}>
                                정확한 혈압측정 &nbsp;
                            </font>
                            방법을 알려 드리겠습니다.
                        </div>

                        <div style={{paddingTop:"50px"}}>
                            <iframe 
                                src={
                                    decodeURIComponent("https://www.youtube.com/embed/OQdVrL4-qEI")+"?enablejsapi=1&autoplay=1&rel=0&origin="+cfg.webUrl
                                    // 네이버 동영상 "https://tv.naver.com/embed/29060045"
                                }
                                style={iFrameStyle}
                                frameBorder="0" 
                                allowFullScreen 
                            />
                        </div>

                        <div style={{paddingTop:"72px", fontSize:"14px", textAlign:"center", fontWeight:"800"}}>
                            이제 정확한 혈압을 <font color="#7fd2c2" style={{fontSize:"18px"}}>입력</font>해 볼까요?
                        </div>
                    </div>

                    
                </IntroContainer>
            </div>            
        </Fragment>
    );
}